import React, { useState } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    useDisclosure,
    useDraggable,
    RadioGroup, useRadio, VisuallyHidden, cn
} from "@heroui/react";
const PROXY = process.env.REACT_APP_API_URL + 'api/';

export const CustomRadio = (props) => {
    const {
        Component,
        children,
        description,
        getBaseProps,
        getWrapperProps,
        getInputProps,
        getLabelProps,
        getLabelWrapperProps,
        getControlProps,
    } = useRadio(props);

    return (
        <Component
            {...getBaseProps()}
            className={cn(
                "group inline-flex items-center hover:opacity-70 active:opacity-50 justify-between flex-row-reverse tap-highlight-transparent",
                "max-w-[300px] cursor-pointer border-2 border-default rounded-lg gap-4 p-4",
                "data-[selected=true]:border-primary",
            )}
        >
            <VisuallyHidden>
                <input {...getInputProps()} />
            </VisuallyHidden>
            <span {...getWrapperProps()}>
                <span {...getControlProps()} />
            </span>
            <div {...getLabelWrapperProps()}>
                {children && <span {...getLabelProps()}>{children}</span>}
                {description && (
                    <span className="text-small text-foreground opacity-70">{description}</span>
                )}
            </div>
        </Component>
    );
};

const GenerateSampleFile = ({ leadType }) => {

    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState(leadType === 'Tvs' ? "manual" : "dynamic");

    // const targetRef = React.useRef(null);
    // const { moveProps } = useDraggable({ targetRef, canOverflow: true, isDisabled: !isOpen });

    const handleDownloadType = () => {
        if (leadType === 'Ola' || leadType === 'Tvs' || leadType === 'Ampere' || leadType === 'Dialshree' || leadType === 'DialShreeLeads' || leadType === 'RevoltTvsLeadverification' || leadType === 'Simple') {
            handleGenerateFile();
        } else {
            onOpen();
        }
    }

    const getApiEndpoint = (leadType, selectedOption) => {
        const dynamicEndpoints = {
            Ola: 'olaleads/generateCsvSample',
            Ampere: 'ampereLeads/generateCsvSample',
            Dialshree: 'dialshree/generateSampleFile',
            RevoltTvsLeadverification: 'olaleads/leadverification/generateSampleFile',
            Simple: 'simple-leads/generateCsvSample',
        };

        const manualOverrides = {
            Revolt: 'olaleads/manualUpload/revolt/generateCsvSample',
            Tvs: 'tvs-leads/generateCsvSampleForDirectUpload',
        };

        const dynamicOverrides = {
            Revolt: 'olaleads/revolt/generateCsvSample',
            // Tvs: 'tvs-leads/generateCsvSample',
        };

        if (selectedOption === 'dynamic') {
            return PROXY + (dynamicOverrides[leadType] || dynamicEndpoints[leadType] || `${leadType}/generateCsvSample`);
        } else {
            return PROXY + (manualOverrides[leadType] || `${leadType}/generateCsvSample`);
        }
    };


    const getFileName = (leadType, selectedOption) => {
        const getCurrentDateTimeIST = () => {
            const date = new Date();

            const options = {
                timeZone: 'Asia/Kolkata',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            };

            const formatter = new Intl.DateTimeFormat('en-IN', options);
            const parts = formatter.formatToParts(date);

            const getPart = (type) => parts.find((part) => part.type === type)?.value;

            const year = getPart('year');
            const month = getPart('month');
            const day = getPart('day');
            const hour = getPart('hour');
            const minute = getPart('minute');
            const dayPeriod = getPart('dayPeriod');

            return `${day}-${month}-${year}_Time_${hour}:${minute}_${dayPeriod}`;
        };


        const currentDateTime = getCurrentDateTimeIST();
        return `sample_${leadType === 'user' ? 'dealers' : `${leadType}-${selectedOption}-${currentDateTime}`}.xlsx`;
    };


    const handleGenerateFile = async () => {
        try {
            setLoading(true);

            const apicalling = getApiEndpoint(leadType, selectedOption);

            const response = await axios.get(apicalling, {
                responseType: 'blob'
            });

            // Create download link
            if (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', getFileName(leadType, selectedOption));
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                setLoading(false);
                toast.success('Sample file generated successfully');
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error('Error generating sample file:', error);
            toast.error('Failed to generate sample file');
        }
    };

    return (
        <>
            <button
                onClick={handleDownloadType}
            >
                Generate Sample File
            </button>
            <Modal size='2xl' isOpen={isOpen} onOpenChange={onOpenChange}>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">
                                Select Sample File
                            </ModalHeader>
                            <ModalBody >
                                <RadioGroup
                                    className='flex'
                                    value={selectedOption}
                                    onValueChange={(val) => setSelectedOption(val)}
                                >
                                    <div className="flex gap-4">
                                        <CustomRadio description="Upload Leads Sample File" value="dynamic">
                                            Dynamic
                                        </CustomRadio>
                                        <CustomRadio description="Upload Leads Sample File" value="manual">
                                            Manual
                                        </CustomRadio>
                                    </div>
                                </RadioGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" variant="flat" onPress={onClose}>
                                    <p className="text-primary-900">Cancel</p>
                                </Button>
                                <Button color="success" isLoading={loading} onPress={() => {
                                    handleGenerateFile();
                                    onClose();
                                }}>
                                    <p className='text-white'>Download</p>
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
            <Toaster position="top-right" reverseOrder={false} />
        </>
    );
};

export default GenerateSampleFile;